export default __webpack_public_path__ + "static/media/consultation-icon.ca5bcd49.svg";